import {Button, message, Spin, Steps} from "antd";
import {SBack, SMessage} from "shj-components";

import {useSetState} from "ahooks";
import {useEffect, useRef} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import {getUser} from "shj-utils";
import {getBizTypes} from "@/services/callCenter";
import {getRealEstateList} from "@/services/homeService.ts";
import {
  getBudGetEnums,
  getHouseDecorateStyleEnum,
  getHouseKindEnum,
  getHouseStatusEnum,
  getHouseTypeEnum, getPermanentResidentsEnum
} from "@/services/customerServices.ts";
import {measureDetail, measureRoomConfig} from "@/services/crmTool.ts";

import MeasureContext from './measureContext.ts'
import {Step1} from "./step1.tsx";
import {Step2} from "./step2.tsx";
import {Step3} from "./step3.tsx";
import {Step4} from "./step4.tsx";
import styles from './index.module.less'
import {getBusinessDictList} from "@/services/product.ts";
import {get} from "lodash-es";
import {getTags} from "@/services/user.ts";

export const AddOrEditRoomMeasureSteps = () => {
  const {id} = useParams()
  const user = getUser()
  const stepRef = useRef()

  const [state, setState] = useSetState<any>({
    current: 0,
    loading: false,
  })

  const [detailInfo, setDetailInfo] = useSetState<any>({})

  const [dictionaryData, setDictionaryData] = useSetState<any>({
    buildList: [],
    houseStatus: [],
    houseType: [],
    layout: [],
    bizTypes: [],
    designStyle: [],
    permanentResidents: [],
  });

  useEffect(() => {
    getOptions(id)
  }, [id]);

  const getInfo = async () => {
    const res = await measureDetail(id)
    setDetailInfo(res)
  }

  const getOptions = async (id) => {
    try {
      setState({loading: true})
      const resList: any = await Promise.allSettled([
        getRealEstateList({orgId: user.companyId}),
        getHouseStatusEnum(),
        getHouseKindEnum(),
        getHouseTypeEnum(),
        getBizTypes(),
        getHouseDecorateStyleEnum(),
        getPermanentResidentsEnum(),
        getBudGetEnums(),
        getBusinessDictList({data: {priKey: 'pets'}}),
        getBusinessDictList({data: {priKey: 'house_renovation_demand'}}),
        getBusinessDictList({data: {priKey: 'age_range'}}),
        getTags({tagCategoryCode: 'TC03'}),
        measureRoomConfig({code: 'measure_room'})
      ])
      if(id) await getInfo()
      resList?.[12]?.value && getConfigMap(resList?.[12]?.value)
      const dataObj = {
        buildList: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
        houseStatus: resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [],
        houseType: resList?.[2]?.value instanceof Array ? resList?.[2]?.value : [],
        layout: resList?.[3]?.value instanceof Array ? resList?.[3]?.value : [],
        bizTypes: resList?.[4]?.value instanceof Array ? resList?.[4]?.value : [],
        designStyle: resList?.[5]?.value instanceof Array ? resList?.[5]?.value : [],
        permanentResidents: resList?.[6]?.value instanceof Array ? resList?.[6]?.value : [],
        budget: resList?.[7]?.value instanceof Array ? resList?.[7]?.value : [],
        pets: resList?.[8]?.value instanceof Array ? getDictList(resList?.[8]?.value) : [],
        houseDemand: resList?.[9]?.value instanceof Array ? getDictList(resList?.[9]?.value) : [],
        ageRange: resList?.[10]?.value instanceof Array ? getDictList(resList?.[10]?.value) : [],
        competitorCompanies: resList?.[11]?.value instanceof Array ? resList?.[11]?.value : [],
      }
      setDictionaryData(dataObj)
    } finally {
      setState({loading: false})
    }
  }

  const getDictList = (list) => {
    const data =  get(list, '[0].children[0].children[0].children', [])
    return data.map(item => ({...item, ...item.object}))
  }

  const getConfigMap = (data) => {
    try {
    const obj = {}
      const configs = JSON.parse(data.configs)
      for (const config of configs) {
        switch (config['configKey']) {
          case 'waterQuality':
            obj['WATER'] = {
              solubleData: handleOption(config.item, '1L中含有可溶性物质㎎标准'),
              ecData: handleOption(config.item,'EC值'),
            }
            break;
          case 'air':
            obj['AIR'] = {
              pm25Data: handleOption(config.item,'PM2.5'),
            }
            break;
          case 'voice':
            obj['VOICE'] = {
              // areaData: handleOption(config.item,'区域'),
              valueData: handleOption(config.item,'值'),
            }
            break;
          case 'light':
            obj['LIGHT'] = {
              // areaData: handleOption(config.item,'区域'),
              valueData: handleOption(config.item,'值'),
            }
            break;
        }
      }
      setDictionaryData({measureRoomConfig: obj})
    } catch (e) {
      console.log(e)
    }
  }

  const handleOption = (data, name) => {
    return data?.find(item => item.itemName === name).options //?.map(op => ({...op, key: op.key + '__' + op.label}))
  }

  const steps = [
    {
      title: '房屋信息',
      children: <Step1 stepRef={stepRef} dictionaryData={dictionaryData}/>
    },
    {
      title: '需求梳理',
      children: <Step2 stepRef={stepRef} dictionaryData={dictionaryData}/>
    },
    {
      title: '检测建议',
      children: <Step3 stepRef={stepRef}/>
    },
    {
      title: '对内信息',
      children: <Step4 stepRef={stepRef} dictionaryData={dictionaryData}/>
    },
  ]

  const updateDetail = (newObj) => {
    setDetailInfo({...detailInfo, ...newObj})
  }

  const setLoading = (loading: boolean) => {
    setState({loading})
  }

  const onPrev = () => {
    stepRef['step' + (state.current + 1)]?.onSaveCache()?.then((res) => {
      updateDetail(res)
      setState({current: state.current - 1})
    })
  }
  const onNext = () => {
    stepRef['step' + (state.current + 1)]?.onSubmit()?.then((res) => {
      updateDetail(res)
      if( state.current < steps.length - 1){
        setState({current: state.current + 1})
      } else {
        message.success('操作成功')
        history.back()
      }
    }).finally(() => {
      setState({loading: false})
    })
  }

  const onCancel = () => {
    SMessage.confirm({
      title: '是否确认返回',
      content: null,
      onOk(){
        history.back()
      }
    })
  }

  const extraRender = () => {
    return <div className={styles.btns}>
      <Button disabled={state.loading} onClick={onCancel}>取消</Button>
      <Button disabled={state.current <= 0 || state.loading} style={{marginLeft: 10}} onClick={onPrev}>上一步</Button>
      <Button disabled={state.loading} type={"primary"} style={{marginLeft: 10}} onClick={onNext}> {state.current >= steps.length -1 ? '提交' : '下一步'}</Button>
    </div>
  }

  return <MeasureContext.Provider value={{detailInfo, updateDetail, setLoading, measureRoomConfig: dictionaryData.measureRoomConfig}}>
    <SBack title={'量房信息'} level={2} extra={extraRender()}>
      <Spin spinning={state.loading}>
        <div className={styles.bgWhite}>
          <div className={styles.stepBox}>
            <div className={styles.stepWrap}>
              <Steps current={state.current} labelPlacement="vertical" items={steps}/>
            </div>
          </div>
          <div className={styles.content}>{steps[state.current]?.children}</div>
        </div>
      </Spin>
    </SBack>
  </MeasureContext.Provider>
}